import useStore from "@/store";
import React from "react";

export const PrintActivatedCard = React.forwardRef(
  ({ serialNumber, code, phone, transactionId, clientId, cardName }, ref) => {
    const currentUser = useStore(state => state.currentUser).user.username;

    return (
      <div ref={ref} className="m-[10px] border-dashed border w-64 text-sm p-2">
        <div className="h-24 flex justify-center items-center flex-col">
          <img
            className="mt-4 w-7/12"
            src="/images/logo/hblogotitle.png"
            alt="Digital Home Logo"
          />
          <p>www.digital-home.org</p>
        </div>
        <p>------------------------------------</p>
        <div className="space-y-1">
          <p className="text-xs">
            Store: <span className="font-bold capitalize">{currentUser}</span>
          </p>
          <p>
            Product: <span className="font-bold">{cardName}</span>
          </p>

          {serialNumber && (
            <p>
              Serial Number: <span className="font-bold">{serialNumber}</span>
            </p>
          )}

          {code && (
            <p>
              Code:{" "}
              <span className="font-bold">
                {code?.match(/.{1,4}/g).join(" ")}
              </span>
            </p>
          )}

          {phone && (
            <p>
              Phone: <span className="font-bold">{phone}</span>
            </p>
          )}

          {transactionId && (
            <p>
              Transaction Id: <span className="font-bold">{transactionId}</span>
            </p>
          )}

          {clientId && (
            <p>
              Client Id: <span className="font-bold">{clientId}</span>
            </p>
          )}
        </div>
      </div>
    );
  }
);

PrintActivatedCard.displayName = "PrintActivatedCard";
export default PrintActivatedCard;
